import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	checkBoxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	all: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	trueMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	checkBoxLabel: {
		id: 'jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.check-box-label',
		defaultMessage: 'Restrict to last commented by non-developers',
		description: 'Text for a checkbox that sets value to true when checked',
	},
	all: {
		id: 'jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.all',
		defaultMessage: 'All',
		description:
			'In the button trigger this indicates that the user added a JQL clause but have not set any RHS values',
	},
	trueMessage: {
		id: 'jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.true-message',
		defaultMessage: 'true',
		description:
			'In the button trigger this indicates that the user wants to restrict issue search to only issues last commented by non-developers',
	},
});
export default messages;
